import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Sign from "../views/Sign.vue";
import AboutUs from "../views/AboutUs.vue";
import ContactUs from "../views/ContactUs.vue";
import info from "../views/panel/info.vue";
import recivers from "../views/panel/recivers.vue";
import orderHistory from "../views/panel/orderHistory.vue";
import comment from "../views/panel/comment.vue";
import newOrder from "../views/panel/newOrder.vue";
import orderDetails from "../views/panel/orderDetails.vue";
import paymentSuccess from "../views/PaymentStatusBank/PaymentSuccess.vue";
import paymentFail from "../views/PaymentStatusBank/PaymaentFailed.vue";
import guid from "../views/guid.vue";
import P404 from "../views/P404";
import tracking from "../views/PaymentStatusBank/Tracking.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/sign",
    name: "Sign",
    component: Sign,
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    component: ContactUs,
  },
  {
    path: "/panelInfo",
    name: "info",
    component: info,
  },
  {
    path: "/panelRecivers",
    name: "recivers",
    component: recivers,
  },
  {
    path: "/panelOrderHistory",
    name: "orderHistory",
    component: orderHistory,
  },
  {
    path: "/orderDetails/:id",
    name: "orderDetails",
    component: orderDetails,
  },
  {
    path: "/tracking/:id",
    name: "tracking",
    component: tracking,
  },
  {
    path: "/panelComment",
    name: "comment",
    component: comment,
  },
  {
    path: "/panelNewOrder",
    name: "newOrder",
    component: newOrder,
  },
  {
    path: "/paymentSuccess",
    name: "paymentSuccess",
    component: paymentSuccess,
  },
  {
    path: "/paymentFail",
    name: "paymentFail",
    component: paymentFail,
  },
  {
    path: "/guid",
    name: "guid",
    component: guid,
  },
  {
    path: "*",
    name: "404",
    component: P404,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

export default router;
